export enum SupervisorAssignedTypeEnum {
    All = 0,
    Assigned = 1,
    Unassigned = 2,
}
